export { default as Shop } from './Shop';
